import { z } from "zod";

export const ColumnSchema = z.object({
  id: z.string().nonempty("This field is required"),
  label: z.string().optional()
});

export const GridSettingsSchema = z.object({
  columns: z.array(ColumnSchema).min(1, "At least one column is required")
});
export type GridSettingsValues = z.infer<typeof GridSettingsSchema>;
